<ngx-slider (userChangeEnd)="onClick($event)" *ngIf="showSlider" [highValue]="highValue" [options]="options"
            [value]="lowValue"></ngx-slider>
